import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './IlHeaderAction/index.js';
import IlHeaderMenuIcon from './IlHeaderMenuIcon/index.js';
import { cssClassPrefix } from '../../../shared/constants/generalConstants.js';

var BASE_CSS = "".concat(cssClassPrefix, "-header-actions");

/**
 * IlHeaderActions Component
 * #### Example implementation
 * ```javascript
 * <IlHeaderActions>
 *   <IlHeaderAction title="" onClick={() => void} icon={ReactElement} caretDown={ReactElement}>
 *     <IlHeaderActionItem itemText="" hasDivider={boolean} onClick={() => void} active={boolean} closeMenuOnClick={boolean}/>
 *   </IlHeaderAction>
 * </IlHeaderActions>
 * ```
 */
var IlHeaderActions = /*#__PURE__*/function (_Component) {
  function IlHeaderActions(props) {
    var _this;
    _classCallCheck(this, IlHeaderActions);
    _this = _callSuper(this, IlHeaderActions, [props]);
    _defineProperty(_this, "handleClickOutside", function (event) {
      if (_this.wrapperRef.current && !_this.wrapperRef.current.contains(event.target)) {
        // Click outside of sidebar menu
        _this.toggleSidebar();
      }
    });
    _defineProperty(_this, "toggleSidebar", function (e) {
      var isSidebarVisible = !_this.state.mobileMenuStatus;
      _this.setState({
        mobileMenuStatus: isSidebarVisible
      });
      if (isSidebarVisible) {
        var ulSelector = "ul.".concat(cssClassPrefix, "-header-action__mobile");
        var ul = _this.wrapperRef.current.querySelector(ulSelector);
        ul.focus();
        ul.trigger = e.target;
        document.addEventListener('mousedown', _this.handleClickOutside);
      } else {
        document.removeEventListener('mousedown', _this.handleClickOutside);
      }
    });
    _this.state = {
      mobileMenuStatus: false
    };
    _this.wrapperRef = /*#__PURE__*/React__default.createRef();
    _this.toggleSidebar = _this.toggleSidebar.bind(_this);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }
  _inherits(IlHeaderActions, _Component);
  return _createClass(IlHeaderActions, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(BASE_CSS, "".concat(BASE_CSS, "--has-multiple-actions")),
        ref: this.wrapperRef
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames("".concat(BASE_CSS, "__wrapper"), _defineProperty({}, "".concat(BASE_CSS, "--open"), this.state.mobileMenuStatus))
      }, this.props.children), /*#__PURE__*/React__default.createElement(IlHeaderMenuIcon, {
        ariaLabel: this.props.mobileMenuButtonAriaLabel,
        onClick: this.toggleSidebar,
        isOpen: this.state.mobileMenuStatus
      }));
    }
  }]);
}(Component);
_defineProperty(IlHeaderActions, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
});
IlHeaderActions.propTypes = {
  mobileMenuButtonAriaLabel: PropTypes.string.isRequired
};

export { IlHeaderActions as default };
